import { 
    getLeaseProcessTableList,
    } from "@/apis/company/leaseMgt.js"; 
import { 
    setMeterNotify,
    } from "@/apis/company/meterRecord.js"; 
    
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_checkbox_status: 'batchMeterNotify/set_checkbox_status',
    set_batch_meter_notify_list: 'batchMeterNotify/set_batch_meter_notify_list',
    set_selected_item: 'batchMeterNotify/set_selected_item',
    set_filter_query: 'batchMeterNotify/set_filter_query',
    set_success_list: 'batchMeterNotify/set_success_list',
}

// count state 必須是 Object
const state = {
    bizBatchMeterNotifyList: [],
    checkboxStatus: {
        checkboxAll: false,
    },
    selectedItem: [],
    filterQuery: {},
    filterQueryUpdate: 0,
    successList: []

}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_BATCH_METER_NOTIFY_LIST: (state) => {
        return state.bizBatchMeterNotifyList
    },
    GET_BIZ_BATCH_METER_NOTIFY_SUCCESS_LIST: (state) => {
        return state.successList
    },
    GET_BIZ_BATCH_METER_NOTIFY_LIST_TOTAL: (state) => {
        return state.bizBatchMeterNotifyList.length
    },
    GET_BIZ_BATCH_METER_NOTIFY_CHECKBOX_STATUS: (state) => {
        return state.checkboxStatus
    },
    GET_BIZ_BATCH_METER_NOTIFY_HAS_SELECTED_HOUSE: (state) => {
        return state.selectedItem.length?true:false
    },
    GET_BIZ_BATCH_METER_NOTIFY_SELECTED_HOUSE_CID: (state) => {
        return state.selectedItem
    },
    GET_BIZ_BATCH_METER_NOTIFY_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_BATCH_METER_NOTIFY_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
    GET_BIZ_BATCH_METER_NOTIFY_LIST_TOTAL: (state) => {
        return state.bizBatchMeterNotifyList.length
    },
    GET_BIZ_BATCH_METER_NOTIFY_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_BATCH_METER_NOTIFY_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizBatchMeterNotifyList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            getLeaseProcessTableList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let result = res.data.result
                    // 相容分頁 (Spring Page: content) 與未分頁 (純陣列) 兩種回傳
                    let batchNotify = Array.isArray(result) ? result : (result.content || [])
                    commit(types.set_batch_meter_notify_list, batchNotify)
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizMeterNotify ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            setMeterNotify(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchMeterNotifyList')
                    commit(types.set_success_list)
                }
                resolve()
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizBatchMeterNotifyCheckboxStatus ( {commit}, data ) {
        commit(types.set_checkbox_status, data)
    },
    setBizBatchMeterNotifySeletedHouse ( {commit}, data ) {
        commit(types.set_selected_item, data)
    },
    setBizBatchMeterNotifyFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setSuccessFlag ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_checkbox_status](state, data){
        state.checkboxStatus = data
    },
    [types.set_selected_item](state, data){
        state.selectedItem = data
    },
    [types.set_batch_meter_notify_list](state, data){
        state.bizBatchMeterNotifyList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.filterQueryUpdate += 1
    },
    [types.set_success_list](state){
        state.successList = state.selectedItem
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/leaseMgt/batchMeterNotify.js